<template>
	<div>
		<div v-for="formElement in parent.formElements" v-bind:key="formElement.elementid">
			<div v-if="formElement.display">

				<!-- Bool button -->
				<button
					v-if="formElement.type == 'bool'"
					class="btn float-left mr-2 mb-2"
					v-bind:class="[
						formElement.cssclass,
						{
							'btn-on': formElement.value,
							'btn-off': !formElement.value,
							'requiredincomplete': formElement.requiredIncomplete
						}
					]"
					v-on:click.stop="toggleSelection(formElement, true)"
					:disabled="treatmentsession.isLocked"
				>
					{{ formElement.caption }}
				</button>

				<!-- Flag button -->
				<button
					v-if="formElement.type == 'flag'"
					class="btn btn-on-bad float-left mr-2 mb-2"
					v-bind:class="{ 'btn-on': formElement.value, 'btn-off': !formElement.value }"
					v-on:click.stop="toggleSelection(formElement, true)"
					:disabled="treatmentsession.isLocked"
				>
					{{ formElement.caption }}
				</button>

				<!-- Select buttons -->
				<div v-if="formElement.type == 'select'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click.stop="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<div class="btn-group btn-group-vertical-sm" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }" style="display: block">
						<button
							v-for="item in formElement.values"
							v-bind:key="item.value"
							class="btn"
							v-bind:class="[
								item.cssclass,
								{
									'btn-on': formElement.value == item.value,
									'btn-off': formElement.value != item.value
								}
							]"
							v-on:click.stop="toggleSelection(formElement, item.value)"
							:disabled="treatmentsession.isLocked"
						>
							{{ item.caption }}
						</button>
					</div>
				</div>

				<!-- Multiselect buttons -->
				<div v-if="formElement.type == 'multiselect'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click.stop="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<div class="btn-group btn-group-vertical-sm" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }" style="display: block">
						<button
							v-for="item in formElement.values"
							v-bind:key="item.value"
							class="btn"
							v-bind:class="[
								item.cssclass,
								{
									'btn-on': formElement.value[item.value],
									'btn-off': !formElement.value[item.value]
								}
							]"
							v-on:click.stop="toggleMultiSelection(formElement, item.value)"
							:disabled="treatmentsession.isLocked"
						>
							{{ item.caption }}
						</button>
					</div>
				</div>

				<!-- Text -->
				<div v-if="formElement.type == 'text'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click.stop="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<input
						v-model="formElement.value"
						class="form-control"
						v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }"
						v-bind:autosize=formElement.autosize
						:disabled="treatmentsession.isLocked"
					/>
				</div>

				<!-- Textarea -->
				<div v-if="formElement.type == 'textarea'" class="form-group clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click.stop="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<textarea-autosize
						v-model="formElement.value"
						class="form-control"
						v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }"
						v-bind:autosize=formElement.autosize
						:disabled="treatmentsession.isLocked"
					></textarea-autosize>
				</div>

				<!-- Toothmap -->
				<div v-if="formElement.type == 'toothmap'" class="toothmap clear-left">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click.stop="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<div class="tmadultrow">
						<p class="text-sm">{{$t("adult")}}</p>
						<div class="tmtop">
							<div class="btn-group mr-2 mb-2" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }">
								<button
									v-for="index in 8"
									v-bind:key="index"
									class="btn"
									v-bind:class="{
										'btn-on': formElement.value[index],
										'btn-off': !formElement.value[index]
									}"
									v-on:click.stop="toggleMultiSelection(formElement, index)"
									:disabled="treatmentsession.isLocked"
								>{{ toothmaplabels[index][toothchartnotationstyle] }}</button>
							</div>
							<div class="btn-group mr-2 mb-2" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }">
								<button
									v-for="index in 8"
									v-bind:key="index"
									class="btn"
									v-bind:class="{
										'btn-on': formElement.value[index + 8],
										'btn-off': !formElement.value[index + 8]
									}"
									v-on:click.stop="toggleMultiSelection(formElement, index + 8)"
									:disabled="treatmentsession.isLocked"
								>{{ toothmaplabels[index + 8][toothchartnotationstyle] }}</button>
							</div>
						</div>
						<div class="tmbottom">
							<div class="btn-group mr-2 mb-2" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }">
								<button
									v-for="index in 8"
									v-bind:key="index"
									class="btn"
									v-bind:class="{
										'btn-on': formElement.value[33-index],
										'btn-off': !formElement.value[33-index]
									}"
									v-on:click.stop="toggleMultiSelection(formElement, 33-index)"
									:disabled="treatmentsession.isLocked"
								>{{ toothmaplabels[33-index][toothchartnotationstyle] }}</button>
							</div>
							<div class="btn-group mr-2 mb-2" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }">
								<button
									v-for="index in 8"
									v-bind:key="index"
									class="btn"
									v-bind:class="{
										'btn-on': formElement.value[25-index],
										'btn-off': !formElement.value[25-index]
									}"
									v-on:click.stop="toggleMultiSelection(formElement, 25-index)"
									:disabled="treatmentsession.isLocked"
								>{{ toothmaplabels[25-index][toothchartnotationstyle] }}</button>
							</div>
						</div>
					</div>
					<div class="tmswitches">
						<div class="btn-group mr-2 mb-2" style="display: block" v-if="toothchartnotationswitchable">
							<button
								v-for="(notationstyle, key) in toothchartnotationoptions"
								v-bind:key="key"
								class="btn"
								v-bind:class="{
									'btn-on': toothchartnotationstyle == key,
									'btn-off': toothchartnotationstyle != key
								}"
								v-on:click.stop="toothchartnotationstyle = key"
							>
								{{ notationstyle }}
							</button>
						</div>
						<button
							class="btn mr-2 mb-2"
							v-bind:class="{
								'btn-on': formElement.showPrimary,
								'btn-off': !formElement.showPrimary
							}"
							v-on:click.stop="formElement.showPrimary = !formElement.showPrimary"
						>
							{{ $t('primary') }}
						</button>
					</div>
					<div class="tmprimaryrow" v-if="formElement.showPrimary">
						<p class="text-sm">{{$t('primary')}}</p>
						<div class="tmtop">
							<div class="btn-group mr-2 mb-2" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }">
								<button
									v-for="index in 5"
									v-bind:key="index"
									class="btn"
									v-bind:class="{
										'btn-on': formElement.value['pri_' + index],
										'btn-off': !formElement.value['pri_' + index]
									}"
									v-on:click.stop="toggleMultiSelection(formElement, 'pri_' + index)"
									:disabled="treatmentsession.isLocked"
								>{{ primarylabels[index][toothchartnotationstyle] }}</button>
							</div>
							<div class="btn-group mr-2 mb-2" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }">
								<button
									v-for="index in 5"
									v-bind:key="index"
									class="btn"
									v-bind:class="{
										'btn-on': formElement.value['pri_' + (index + 5)],
										'btn-off': !formElement.value['pri_' + (index + 5)]
									}"
									v-on:click.stop="toggleMultiSelection(formElement, 'pri_' + (index + 5))"
									:disabled="treatmentsession.isLocked"
								>{{ primarylabels[index + 5][toothchartnotationstyle] }}</button>
							</div>
						</div>
						<div class="tmbottom">
							<div class="btn-group mr-2 mb-2" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }">
								<button
									v-for="index in 5"
									v-bind:key="index"
									class="btn"
									v-bind:class="{
										'btn-on': formElement.value['pri_' + (21-index)],
										'btn-off': !formElement.value['pri_' + (21-index)]
									}"
									v-on:click.stop="toggleMultiSelection(formElement, 'pri_' + (21-index))"
									:disabled="treatmentsession.isLocked"
								>{{ primarylabels[21-index][toothchartnotationstyle] }}</button>
							</div>
							<div class="btn-group mr-2 mb-2" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }">
								<button
									v-for="index in 5"
									v-bind:key="index"
									class="btn"
									v-bind:class="{
										'btn-on': formElement.value['pri_' + (16-index)],
										'btn-off': !formElement.value['pri_' + (16-index)]
									}"
									v-on:click.stop="toggleMultiSelection(formElement, 'pri_' + (16-index))"
									:disabled="treatmentsession.isLocked"
								>{{ primarylabels[16-index][toothchartnotationstyle] }}</button>
							</div>
						</div>
					</div>
				</div>

				<div v-if="formElement.type == 'radiographs'" class="form-group clear-left">
					<div v-for="type in formElement.types" v-bind:key="type.name" class="clear-left mb-3">
						<label v-if="type.caption" class="mb-0">
							{{type.caption}}
							<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click.stop="showInfo(formElement.caption , formElement.information)">
								<b-icon icon="question"></b-icon>
							</button>
						</label>
						<div class="btn-group mb-1" style="display: block">
							<button
								v-for="index in type.max"
								v-bind:key="index"
								class="btn"
								v-bind:class="{
									'btn-on': type.value.length == index,
									'btn-off': type.value.length != index
								}"
								v-on:click.stop="radioGraphCountChange(type, index)"
								:disabled="treatmentsession.isLocked"
							>
								{{ index }}
							</button>
						</div>
						<div v-for="(item, index) in type.value" v-bind:key="index" class="mb-1">
							<div class="clearfix">
								<div v-if="type.imagequality.length">
									<div class="float-left mr-3">
										<div v-if="index == 0">{{$t('quality')}}</div>
										<div class="btn-group">
											<button
												v-for="option in type.imagequality"
												v-bind:key="option.value"
												class="btn"
												v-bind:class="[
													option.cssclass,
													{
														'btn-on': item.filmquality == option.value,
														'btn-off': item.filmquality != option.value
													}
												]"
												v-on:click.stop="toggleRadiographSelection(item, 'filmquality', option.value)"
												:disabled="!canMark && type.imagequalityteacheronly"
											>
												{{ option.caption }}
											</button>
										</div>
									</div>
								</div>
								<div v-if="type.competence.length">
									<div class="float-left mr-3">
										<div v-if="index == 0">{{ $t('competence') }}</div>
										<div class="btn-group">
											<button
												v-for="option in type.competence"
												v-bind:key="option.value"
												class="btn"
												v-bind:class="[
													option.cssclass,
													{
														'btn-on': item.competence == option.value,
														'btn-off': item.competence != option.value
													}
												]"
												v-on:click.stop="toggleRadiographSelection(item, 'competence', option.value)"
												:disabled="!canMark && type.competenceteacheronly"
											>
												{{ option.caption }}
											</button>
										</div>
									</div>
								</div>
								<div v-if="type.showjustification">
									<div class="float-left mr-3">
										<div v-if="index == 0">{{ $t('justification') }}</div>
										<button
											class="btn"
											v-bind:class="{
												'btn-on': item.justification,
												'btn-off': !item.justification
											}"
											v-on:click.stop="item.justification = !item.justification"
											:disabled="treatmentsession.isLocked"
										>
											{{ $t('justification') }}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div v-if="formElement.type == 'multiplier'" class="clear-left mb-3">
					<label v-if="formElement.caption" class="mb-0">
						{{formElement.caption}}
						<button class="btn btn-light btn-sm ml-1 btn-xs mb-1" v-if="formElement.information" v-on:click.stop="showInfo(formElement.caption , formElement.information)">
							<b-icon icon="question"></b-icon>
						</button>
					</label>
					<div class="btn-group mb-3" style="display: block" v-bind:class="{'requiredincomplete': formElement.requiredIncomplete }">
						<button
							v-for="index in formElement.max"
							v-bind:key="index"
							class="btn"
							v-bind:class="{
								'btn-on': formElement.value.length == index,
								'btn-off': formElement.value.length != index
							}"
							v-on:click.stop="updateChildren(formElement, index)"
							:disabled="treatmentsession.isLocked"
						>
							{{ index }}
						</button>
					</div>

					<div v-for="(item, index) in formElement.value" v-bind:key="index" class="card mb-3">
						<div class="card-header">{{ formElement.multicaption }} {{ index + 1 }}</div>
						<div class="card-body">
							<treatmentsessionformelements
								v-bind:treatmentsession="treatmentsession"
								v-bind:parentprocedure="parentprocedure"
								v-bind:parent="item"
								v-bind:toothchartnotationoptions="toothchartnotationoptions"
								v-bind:toothchartnotationstyle="toothchartnotationstyle"
								v-bind:toothchartnotationswitchable="toothchartnotationswitchable"
								v-bind:toothmaplabels="toothmaplabels"
								v-bind:primarylabels="primarylabels"
							></treatmentsessionformelements>
						</div>
					</div>
				</div>

				<div
					v-if="
						formElement.type != 'multiplier' &&
						'formElements' in formElement &&
						formElement.formElements.length > 0
					"
					style="clear: left;"
				>
					<treatmentsessionformelements
						v-bind:treatmentsession="treatmentsession"
						v-bind:parentprocedure="parentprocedure"
						v-bind:parent="formElement"
						v-bind:toothchartnotationoptions="toothchartnotationoptions"
						v-bind:toothchartnotationstyle="toothchartnotationstyle"
						v-bind:toothchartnotationswitchable="toothchartnotationswitchable"
						v-bind:toothmaplabels="toothmaplabels"
						v-bind:primarylabels="primarylabels"
					></treatmentsessionformelements>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "treatmentsessionformelements",
	props: {
		treatmentsession: Object,
		parentprocedure: Object,
		parent: Object,
		toothchartnotationoptions: Object,
		toothchartnotationstyle: String,
		toothchartnotationswitchable: Boolean,
		toothmaplabels: Array,
		primarylabels: Array
	},
	computed: {
		canMark: function(){
			if(this.treatmentsession.isLocked){
				return false;
			}
			return this.$UserSession.hasPriv.call(this, 'MARK_TREATMENTSESSIONS');
		}
	},
	methods: {
		toggleSelection(formElement, value) {
			if (formElement.value != value) {
				formElement.value = value;
			} else {
				formElement.value = false;
			}
			// Special rule for the flag button
			if(formElement.caption == 'Flag'){
				this.parentprocedure.flagged = !this.parentprocedure.flagged;
			}
		},
		toggleMultiSelection(formElement, select) {
			//alert(JSON.stringify(formElement));
			if (!("value" in formElement)) {
				formElement.value = {
					select: true
				};
			}
			if (!(select in formElement.value)) {
				formElement.value[select] = false;
			}
			if (!formElement.value[select]) {
				if('settings' in formElement){
					if('maxteeth' in formElement.settings && formElement.settings.maxteeth){
						formElement.value = {};
					}
				}
				formElement.value[select] = true;
			} else {
				formElement.value[select] = false;
			}
		},
		updateChildren(formElement, count) {
			if (!("value" in formElement)) {
				formElement.value = [];
			}
			// A "1" selection to be nulled.
			if(count == 1 && count == formElement.value.length){
				formElement.value = [];
			} else {
				// Add new items?
				for (let i = 0; i < count; i += 1) {
					if (!(i in formElement.value)) {
						formElement.value.push({
							formElements: JSON.parse(JSON.stringify(formElement.formElements)),
						});
					}
				}
				// Remove unused items
				var remove = formElement.value.length - count;
				for(var i=0; i<remove; i++){
					this.$delete(formElement.value, formElement.value.length-1);
				}
			}
		},
		toggleRadiographSelection(element, key, value) {
			if (element[key] != value) {
				element[key] = value;
			} else {
				element[key] = false;
			}
		},
		radioGraphCountChange(type, count) {
			if (!("value" in type)) {
				type.value = [];
			}
			// Add new items?
			// A "1" selection to be nulled.
			if(count == 1 && count == type.value.length){
				type.value = [];
			} else {
				for (let i = 0; i < count; i += 1) {
					if (!(i in type.value)) {
						type.value.push({
							filmquality: "",
							competence: "",
							justification: false,
						});
					}
				}
			}
			// Remove unused items
			var remove = type.value.length - count;
			for(var i=0; i<remove; i++){
				this.$delete(type.value, type.value.length-1);
			}
		},
		showInfo: function(caption , information) {
			this.$store.commit("openDialog" , {
				cancelBtn: false ,
				title: caption,
				htmlContent: information,
				size: 'lg'
			});
		}
	},
};
</script>
